import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";
import { API_URLS } from "../../api/apiUrls";
// ─── Async Thunks ──────────────────────────────────────────────────────────
export const setOrgMode = createAsyncThunk(
  "organizationSetup/setOrgMode",
  async ({ userId, orgStructureMode }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(API_URLS.ORG_MODE(userId), {
        orgStructureMode,
      });
      return { ...response.data, orgStructureMode };
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to set organization mode",
      );
    }
  },
);

export const fetchCustomerDocuments = createAsyncThunk(
  "customer/fetchCustomerDocuments",
  async (id, { rejectWithValue }) => {
    try {
      const url = API_URLS.GET_CUSTOMER_DOCUMENTS(id);
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch customer documents";
      return rejectWithValue(message);
    }
  },
);

export const uploadCustomerDocument = createAsyncThunk(
  "customer/uploadCustomerDocument",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const url = API_URLS.UPLOAD_CUSTOMER_DOCUMENT(id);
      const response = await axiosInstance.post(url, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to upload customer document";
      return rejectWithValue(message);
    }
  },
);

export const deleteCustomerDocument = createAsyncThunk(
  "customer/deleteCustomerDocument",
  async ({ id, docId }, { rejectWithValue }) => {
    try {
      const url = API_URLS.DELETE_CUSTOMER_DOCUMENT(id, docId);
      const response = await axiosInstance.delete(url);
      return { data: response.data, docId };
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to delete customer document";
      return rejectWithValue(message);
    }
  },
);

export const fetchCustomerById = createAsyncThunk(
  "customer/fetchCustomerById",
  async (id, { rejectWithValue }) => {
    try {
      const url = API_URLS.GET_CUSTOMER_BY_ID(id);
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch customer details";
      return rejectWithValue(message);
    }
  },
);

export const updateCustomerProfile = createAsyncThunk(
  "customer/updateCustomerProfile",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const url = API_URLS.UPDATE_CUSTOMER_PROFILE(id);
      const response = await axiosInstance.put(url, data);
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to update customer profile";
      return rejectWithValue(message);
    }
  },
);

export const sendCustomerOtp = createAsyncThunk(
  "customer/sendCustomerOtp",
  async ({ id, email }, { rejectWithValue }) => {
    try {
      const url = API_URLS.CUSTOMER_SEND_OTP(id);
      const response = await axiosInstance.post(url, { email });
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to send OTP";
      return rejectWithValue(message);
    }
  },
);

export const verifyCustomerOtp = createAsyncThunk(
  "customer/verifyCustomerOtp",
  async ({ id, email, otp }, { rejectWithValue }) => {
    try {
      const url = API_URLS.CUSTOMER_VERIFY_OTP_NEW(id);
      const response = await axiosInstance.post(url, { email, otp });
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to verify OTP";
      return rejectWithValue(message);
    }
  },
);

//------Group under client----------------
export const fetchGroupUnderClient = createAsyncThunk(
  "customer/fetchGroupUnderClient",
  async (id, { rejectWithValue }) => {
    try {
      const url = API_URLS.GET_GROUP_UNDER_CLIENT(id);
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch customer details";
      return rejectWithValue(message);
    }
  },
);
//------Location----------------
export const fetchAddedLocation = createAsyncThunk(
  "customer/fetchAddedLocation",
  async (id, { rejectWithValue }) => {
    try {
      const url = API_URLS.GET_ADDED_LOCATION(id);
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch customer details";
      return rejectWithValue(message);
    }
  },
);
//---GET DEPARTMENT------------------
export const fetchAllDepartments = createAsyncThunk(
  "group/fetchAllDepartments",
  async (
    {id},
    { rejectWithValue },
  ) => {
    try {
      const url = API_URLS.GET_DEPARTMENT(id);
    

      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch department";
      return rejectWithValue(message);
    }
  },
);
//--------------GET ALL CUSTOMER----------------------
export const getAllClients = createAsyncThunk(
  "customer/getAllClients",
  async (
    {
      pageNo = 1,
      limit = 10,
      sort = "-createdAt",
      search = "",
      filter = "",
    } = {},
    { rejectWithValue },
  ) => {
    try {
      const url = API_URLS.GET_ALL_CUSTOMER(
        pageNo,
        limit,
        sort,
        search,
        filter,
      );
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch customers";
      return rejectWithValue(message);
    }
  },
);
//----UPDATE CUSTOMER STATUS--------------------
export const updateClientStatus = createAsyncThunk(
  "customer/updateClientStatus",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const url = API_URLS.UPDATE_CUSTOMER_STATUS(id);
      const response = await axiosInstance.patch(url, data);

      return { id, status: data.status, response: response.data };
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to update customer status";
      return rejectWithValue(message);
    }
  },
);
// Async thunk for creating a department
export const createDepartment = createAsyncThunk(
  "department/createDepartment",
  async ({ userId, data }, { rejectWithValue }) => {
    try {
      const url = API_URLS.CREATE_DEPARTMENT(userId);
        
      const response = await axiosInstance.post(url, {
        ...data,
        clientId: userId
      });

      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to create department";
      return rejectWithValue(message);
    }
  },
);
//---Delete Department-------------------
export const deleteDepartment = createAsyncThunk(
  "group/deleteDepartment",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(
        API_URLS.DELETE_DEPARTMENT(id),
      );
      return { id };
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to delete department",
      );
    }
  },
);
export const updateDepartment = createAsyncThunk(
  "group/updateDepartment",
  async ({departmentId, payload }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        API_URLS.UPDATE_DEPARTMENT(departmentId),
        payload,
      );
      return {  payload };
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to update department",
      );
    }
  },
);
//---GET LINKED ITEMS------------------
export const fetchLinkedItems = createAsyncThunk(
  "organizationSetup/fetchLinkedItems",
  async ({ id, userId }, { rejectWithValue }) => {
    try {
      const url = API_URLS.GET_DEPARTMENTS(id, userId);
      const response = await axiosInstance.get(url);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch unlinked items",
      );
    }
  },
  
);
//---GET LOCATIONS------------------
export const fetchAllLocations = createAsyncThunk(
  "group/fetchAllLocations",
  async (id, { rejectWithValue }) => {
    try {
      const url = API_URLS.GET_LOCATIONS_OF_CLIENT(id);
      const response = await axiosInstance.get(url);
      return response.data.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch location";
      return rejectWithValue(message);
    }
  },
);
//---Delete Location-------------------
export const deleteLocation = createAsyncThunk(
  "group/deleteLocation",
  async ({locationId}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(API_URLS.DELETE_LOCATION( locationId));
      return { locationId };
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to delete location",
      );
    }
  },
);
//----CREATE MAPPING-----------------
export const createMapping = createAsyncThunk(
  "group/createMapping",
  async ({ userId, data }, { rejectWithValue }) => {
    try {
      const url = API_URLS.CREATE_MAPPING(userId);

      const response = await axiosInstance.post(url, data);

      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to create mapping";

      return rejectWithValue(message);
    }
  },
);
//---Update Location-------------------
export const updateLocation = createAsyncThunk(
  "group/updateLocation",
  async ({  id, payload }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        API_URLS.UPDATE_LOCATION( id),
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to update location",
      );
    }
  },
);

// export const deleteLocation = createAsyncThunk(
//   "group/deleteLocation",
//   async ({ userId, locationId }, { rejectWithValue }) => {
//     try {
//       const response = await axiosInstance.delete(
//         API_URLS.DELETE_LOCATION(userId, locationId),
//       );
//       return { locationId };
//     } catch (error) {
//       return rejectWithValue(
//         error?.response?.data?.message || "Failed to delete location",
//       );
//     }
//   },
// );
//---ADD LOCATION--------------------
export const createLocation = createAsyncThunk(
  "group/createLocation",
  async ({ userId, formData }, { rejectWithValue }) => {
    try {
      const url = API_URLS.CREATE_LOCATION(userId);
      const response = await axiosInstance.post(url, { ...formData, clientId: userId });
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to create location";
      return rejectWithValue(message);
    }
  },
);
//----Link-----------------
export const fetchDepartmentLinkedEntities = createAsyncThunk(
  "group/fetchDepartmentLinkedEntities",
  async ({ id, customerId }, { rejectWithValue }) => {
    try {
      const url = API_URLS.GET_LINKED(id, customerId);
      const response = await axiosInstance.get(url);
      return response.data.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch linked department";
      return rejectWithValue(message);
    }
  },
);
//----Unlink------------------
export const fetchDepartmentUnlinkedEntities = createAsyncThunk(
  "group/fetchDepartmentUnlinkedEntities",
  async (_, { rejectWithValue }) => {
    try {
      const url = API_URLS.GET_UNLINKED;
      const response = await axiosInstance.get(url);
      return response.data.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch unlinked department";
      return rejectWithValue(message);
    }
  },
);
//---GET UNLINKED ITEMS------------------
export const fetchUnlinkedItems = createAsyncThunk(
  "organizationSetup/fetchUnlinkedItems",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(API_URLS.GET_UNLINKED);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch unlinked items",
      );
    }
  },
);

export const parseCsv = createAsyncThunk(
  "customer/parseCsv",
  async ({ userId, file, type }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const url = type === "location" ? API_URLS.LOCATION_CSV_PARSE(userId) : API_URLS.CSV_PARSE(userId);
      const response = await axiosInstance.post(url, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || "Failed to parse CSV");
    }
  }
);
export const CustomerparseCsv = createAsyncThunk(
  "customer/CustomerparseCsv",
  async ({ userId, file }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await axiosInstance.post(API_URLS.CUSTOMER_CSV_PARSE(userId), formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || "Failed to parse CSV");
    }
  }
);

export const validateCsvMapping = createAsyncThunk(
  "customer/validateCsvMapping",
  async ({ userId, mapping, type }, { rejectWithValue }) => {
    try {
      const url = type === "location" ? API_URLS.LOCATION_CSV_VALIDATE(userId) : API_URLS.CSV_VALIDATE(userId);
      const response = await axiosInstance.post(url, { mapping });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || "Failed to validate mapping");
    }
  }
);

export const importCsvData = createAsyncThunk(
  "customer/importCsvData",
  async ({ userId, mapping, file, type }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("columnMapping", JSON.stringify(mapping));
      
      const url = type === "location" ? API_URLS.LOCATION_CSV_IMPORT(userId) : API_URLS.CSV_IMPORT(userId);
      const response = await axiosInstance.post(url, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || "Failed to import data");
    }
  }
);
export const importCustomerCsvData = createAsyncThunk(
  "customer/importCustomerCsvData",
  async ({ userId, mapping, file }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("columnMapping", JSON.stringify(mapping));
      
      const response = await axiosInstance.post(API_URLS.CUSTOMER_CSV_IMPORT(userId), formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || "Failed to import data");
    }
  }
);

export const fetchCustomerFilteredProjects = createAsyncThunk(
  "customer/fetchCustomerFilteredProjects",
  async (
    {
      clientId,
      limit = 10,
      skip = 0,
      sort = "-createdAt",
      search = "",
      filterData = "",
    },
    { rejectWithValue },
  ) => {
    try {
      const url = API_URLS.GET_CUSTOMER_FILTERED_PROJECTS(
        limit,
        skip,
        sort,
        search,
        filterData,
      );
      const response = await axiosInstance.get(url, {
        headers: { client: clientId },
      });
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch customer projects";
      return rejectWithValue(message);
    }
  },
);

export const updateSubAdminLicense = createAsyncThunk(
  "customer/updateSubAdminLicense",
  async ({ projectId, data }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(
        API_URLS.UPDATE_SUB_ADMIN_LICENSE(projectId),
        data,
      );
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to update project license";
      return rejectWithValue(message);
    }
  },
);

const initialState = {
  currentCustomer: null,
  customerDocuments: [],
  saving: false,
  error: null,
   createMapping: false,
  customerGroup: [],
  customerAddedLocation: [],
  loading: false,
  groupClientLoading: false,
  getLocationLoading: false,
  customerLoading: false,
  fetchDepartmentsLoading:false,
  unlinkedEntitiesError:null,
  allCustomers: [],
  departmentList:[],
  departmentTotal: 0,
  search: "",
  limit: 10,
  skip: 0,
  currentStatus: null,
  otpSent: false,
  otpVerified: false,
  unlinkedEntities:[],
   departmentSuccess: false,
   selectedDepartment: null,
   selectedLocation: null,
    linkedItems:[],
    locationList:[],
    linkedDepartments:[],
    parseResult: null,
    parseCustomerResult:null,
    validateResult: null,
    importResult: null,
    importCustomerResult:null,
   loadingParams: {
     createLocation: false,
    LinkedEntities:false,
     updateDepartments: false,
      fetchLinked: false,
      fetchLocation:false,
      unlinkedEntitiesLoading:false,
      isParsing: false,
      isValidating: false,
      isImporting: false,
      isCustomerImporting:false,
      isCustomerParsing: false,
    },
    linkedEntitiesData: [],
    customerFilteredProjects: [],
    customerFilteredProjectsTotal: 0,
    customerFilteredProjectsLimit: 10,
    customerFilteredProjectsSkip: 0,
    customerFilteredProjectsLoading: false,
    customerFilteredProjectsError: null,
    updateSubAdminLicenseLoading: false,
    updateSubAdminLicenseError: null,
};

// ─── Slice ────────────────────────────────────────────────────────────────

const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    clearCustomerError(state) {
      state.error = null;
    },
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSearch(state, action) {
      state.search = action.payload;
      state.currentPage = 1; // reset to first page on new search
    },
    resetOtpState(state) {
      state.otpSent = false;
      state.otpVerified = false;
      const verification =
        state.currentCustomer?.billing?.billingContact?.emailVerification;
      if (verification) {
        verification.pendingEmail = null;
      }
    },
    setSelectedCustomer(state, action) {
      state.currentCustomer = action.payload;
    },
      setSelectedDepartment: (state, action) => {
      state.selectedDepartment = action.payload;
    },
      setSelectedLocation: (state, action) => {
      state.selectedLocation = action.payload;
    },
      clearDepartmentStatus: (state) => {
      state.departmentSuccess = false;
      state.error = null;
    },
       clearMappingStatus: (state) => {
      state.mappingSuccess = false;
      state.error = null;
    },
      clearSetupError(state) {
      state.error = null;
    },
    clearImportResults(state) {
      state.parseResult = null;
      state.parseCustomerResult = null;
      state.validateResult = null;
      state.importResult = null;
      state.importCustomerResult = null;
    },
  },

  extraReducers: (builder) => {
    builder
        // Set Org Mode
      .addCase(setOrgMode.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.orgModeSuccess = false;
      })
      .addCase(setOrgMode.fulfilled, (state, action) => {
        state.loading = false;
        state.orgModeSuccess = true;
        state.orgModeLocked = true;
        // API response ya triggered action argument se value store mein set kar rhe hain
        state.orgMode =
          action.payload?.data?.orgStructureMode || action.meta.arg;
      })
      .addCase(setOrgMode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // fetchCustomerDocuments
      .addCase(fetchCustomerDocuments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomerDocuments.fulfilled, (state, action) => {
        state.loading = false;
        state.customerDocuments = action.payload?.data ?? [];
      })
      .addCase(fetchCustomerDocuments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.customerDocuments = [];
      })
      // uploadCustomerDocument
      .addCase(uploadCustomerDocument.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadCustomerDocument.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(uploadCustomerDocument.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // deleteCustomerDocument
      .addCase(deleteCustomerDocument.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCustomerDocument.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload?.docId) {
          state.customerDocuments = state.customerDocuments.filter(
            (doc) => doc._id !== action.payload.docId,
          );
        }
      })
      .addCase(deleteCustomerDocument.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // fetchCustomerById
      .addCase(fetchCustomerById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomerById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentCustomer = action.payload?.data ?? null;
      })
      .addCase(fetchCustomerById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.currentCustomer = null;
      })
      // updateCustomerProfile
      .addCase(updateCustomerProfile.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(updateCustomerProfile.fulfilled, (state, action) => {
        state.saving = false;
        if (action.payload?.data) {
          state.currentCustomer = action.payload.data;
        }
      })
      .addCase(updateCustomerProfile.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload;
      })
      .addCase(fetchGroupUnderClient.pending, (state) => {
        state.groupClientLoading = true;
        state.error = null;
      })
      .addCase(fetchGroupUnderClient.fulfilled, (state, action) => {
        state.groupClientLoading = false;
        state.customerGroup = action.payload?.data ?? [];
      })
           //Create Location
      .addCase(createLocation.pending, (state) => {
        state.loadingParams.createLocation = true;
        state.error = null;
      })
      .addCase(createLocation.fulfilled, (state, action) => {
        state.loadingParams.createLocation = false;

        const newLocation = action.payload?.data;

        if (newLocation) {
          state.customerAddedLocation.push(newLocation);
        }
      })
      .addCase(createLocation.rejected, (state, action) => {
        state.loadingParams.createLocation = false;
        state.error = action.payload;
        state.newLocation = [];
      })
      .addCase(fetchGroupUnderClient.rejected, (state, action) => {
        state.groupClientLoading = false;
        state.error = action.payload;
        state.customerGroup = [];
      })
      //------Get Location---------
      .addCase(fetchAddedLocation.pending, (state) => {
        state.getLocationLoading = true;
        state.error = null;
      })
      .addCase(fetchAddedLocation.fulfilled, (state, action) => {
        state.getLocationLoading = false;
        state.customerAddedLocation = action.payload?.data ?? [];
      })
      .addCase(fetchAddedLocation.rejected, (state, action) => {
        state.getLocationLoading = false;
        state.error = action.payload;
        state.customerAddedLocation = [];
      })
      //GET ALL CUSTOMERS
      .addCase(getAllClients.pending, (state) => {
        state.customerLoading = true;
      })

      .addCase(getAllClients.fulfilled, (state, action) => {
        state.customerLoading = false;
        state.allCustomers = action.payload.data;
        state.totalCustomers = action.payload.total;
        state.limit = action.payload.limit;
        state.skip = action.payload.skip;
      })

      .addCase(getAllClients.rejected, (state, action) => {
        state.customerLoading = false;
        state.error = action.payload;
      }).addCase(updateClientStatus.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(updateClientStatus.fulfilled, (state, action) => {
        state.saving = false;

        const { id, status } = action.payload;

        const customer = state.allCustomers.find((c) => c._id === id);

        if (customer) {
          customer.status = status;
        }
      })
      .addCase(updateClientStatus.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload;
      })
      // sendCustomerOtp
      .addCase(sendCustomerOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendCustomerOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.otpSent = true;
        const pendingEmail = action.meta?.arg?.email;
        if (!pendingEmail || !state.currentCustomer) return;

        state.currentCustomer.billing = state.currentCustomer.billing || {};
        state.currentCustomer.billing.billingContact =
          state.currentCustomer.billing.billingContact || {};
        state.currentCustomer.billing.billingContact.emailVerification = {
          ...state.currentCustomer.billing.billingContact.emailVerification,
          isVerified: false,
          pendingEmail: String(pendingEmail).trim().toLowerCase(),
          otp: null,
        };
      })
      .addCase(sendCustomerOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // verifyCustomerOtp
      .addCase(verifyCustomerOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyCustomerOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.otpVerified = true;
        const verifiedEmail =
          action.payload?.data?.email ||
          action.meta?.arg?.email?.trim?.().toLowerCase?.();
        if (verifiedEmail && state.currentCustomer?.billing) {
          if (!state.currentCustomer.billing.billingContact) {
            state.currentCustomer.billing.billingContact = {};
          }
          state.currentCustomer.billing.billingContact.email = verifiedEmail;
          state.currentCustomer.billing.billingContact.emailVerification = {
            isVerified: true,
            pendingEmail: null,
            otp: null,
            expiresAt: null,
          };
        }
      })
      .addCase(verifyCustomerOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
        //Fetch departments
      .addCase(fetchAllDepartments.pending, (state) => {
        state.fetchDepartmentsLoading = true;
        state.error = null;
      })
      .addCase(fetchAllDepartments.fulfilled, (state, action) => {
        state.fetchDepartmentsLoading = false;
        state.departmentList = action.payload?.data ?? [];
        state.departmentTotal = action.payload?.total ?? 0;
      })
      .addCase(fetchAllDepartments.rejected, (state, action) => {
        state.fetchDepartmentsLoading = false;
        state.error = action.payload;
        state.departmentList = [];
      })
        // Create Department
      .addCase(createDepartment.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.departmentSuccess = false;
      })
      .addCase(createDepartment.fulfilled, (state, action) => {
        state.loading = false;
        state.departmentSuccess = true;
        if (action.payload) {
          state.departmentList = [...state.departmentList, action.payload];
        }
      })
      .addCase(createDepartment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.departmentSuccess = false;
      })
      //Delete deaprtment
         .addCase(deleteDepartment.fulfilled, (state, action) => {
        const { id } = action.payload;
        state.departmentList = state.departmentList.filter(
          (department) => department._id !== id,
        );
      })
      //update department
       .addCase(updateDepartment.pending, (state) => {
        state.loadingParams.updateDepartments = true;
        state.error = null;
      })
       //Delete location
      .addCase(deleteLocation.fulfilled, (state, action) => {
        const { locationId } = action.payload;
        state.locationList = (state.locationList || []).filter(
          (location) => location._id !== locationId,
        );
        state.customerAddedLocation = (state.customerAddedLocation || []).filter(
          (location) => location._id !== locationId,
        );
      })
      .addCase(updateDepartment.fulfilled, (state, action) => {
        state.loadingParams.updateDepartments = false;

        const { id, payload } = action.payload;

        const index = state.departmentList.findIndex((loc) => loc._id === id);

        if (index !== -1) {
          state.departmentList[index] = {
            ...state.departmentList[index],
            ...payload,
          };
        }
      })
      .addCase(updateDepartment.rejected, (state, action) => {
        state.loadingParams.updateDepartments = false;
        state.error = action.payload;
      })
            //Fetch linked items
      .addCase(fetchLinkedItems.pending, (state) => {
        state.loadingParams.fetchLinked = true;
        state.error = null;
      })
      .addCase(fetchLinkedItems.fulfilled, (state, action) => {
        state.loadingParams.fetchLinked = false;
        state.linkedDepartments = action.payload ?? [];
      })
      .addCase(fetchLinkedItems.rejected, (state, action) => {
        state.loadingParams.fetchLinked = false;
        state.error = action.payload;
      })
         .addCase(fetchAllLocations.pending, (state) => {
        state.loadingParams.fetchLocation = true;
        state.error = null;
      })
      .addCase(fetchAllLocations.fulfilled, (state, action) => {
        state.loadingParams.fetchLocation = false;
        state.locationList = action.payload ?? [];
      })
      .addCase(fetchAllLocations.rejected, (state, action) => {
        state.loadingParams.fetchLocation = false;
        state.error = action.payload;
        state.locationList = [];
      })
       .addCase(createMapping.pending, (state) => {
        state.loadingParams.mappingLoading = true;
        state.mappingSuccess = false;
        state.mappingError = null;
      })

      .addCase(createMapping.fulfilled, (state, action) => {
        state.loadingParams.mappingLoading = false;
        state.mappingSuccess = true;
        const data = action.payload?.data;

        if (data) {
          if (Array.isArray(data)) {
            state.linkedEntitiesData.push(...data);
          } else {
            state.linkedEntitiesData.push(data);
          }
        }
      })

      .addCase(createMapping.rejected, (state, action) => {
        state.loadingParams.mappingLoading = false;
        state.mappingSuccess = false;
        state.mappingError = action.payload;
      })
         //Fetch linked department
      .addCase(fetchDepartmentLinkedEntities.pending, (state) => {
        state.loadingParams.LinkedEntities = true;
        state.error = null;
      })

      .addCase(fetchDepartmentLinkedEntities.fulfilled, (state, action) => {
        state.loadingParams.LinkedEntities = false;
        state.linkedDepartments = action.payload;
      })

      .addCase(fetchDepartmentLinkedEntities.rejected, (state, action) => {
        state.loadingParams.LinkedEntities = false;
        state.error = action.payload;
      })
        .addCase(fetchDepartmentUnlinkedEntities.pending, (state) => {
        state.loadingParams.unlinkedEntitiesLoading = true;
        state.unlinkedEntitiesError = null;
      })

      .addCase(fetchDepartmentUnlinkedEntities.fulfilled, (state, action) => {
        state.loadingParams.unlinkedEntitiesLoading = false;
        state.unlinkedEntities = action.payload;
      })

      .addCase(fetchDepartmentUnlinkedEntities.rejected, (state, action) => {
        state.loadingParams.unlinkedEntitiesLoading = false;
        state.unlinkedEntitiesError =
          action.payload || "Failed to fetch unlinked entities";
      })
      // parseCsv
      .addCase(parseCsv.pending, (state) => {
        state.loadingParams.isParsing = true;
        state.parseResult = null;
        state.error = null;
      })
      .addCase(parseCsv.fulfilled, (state, action) => {
        state.loadingParams.isParsing = false;
        state.parseResult = action.payload;
      })
      .addCase(parseCsv.rejected, (state, action) => {
        state.loadingParams.isParsing = false;
        state.error = action.payload;
      })
      // customerparseCsv
      .addCase(CustomerparseCsv.pending, (state) => {
        state.loadingParams.isCustomerParsing = true;
        state.parseCustomerResult = null;
        state.error = null;
      })
      .addCase(CustomerparseCsv.fulfilled, (state, action) => {
        state.loadingParams.isCustomerParsing = false;
        state.parseCustomerResult = action.payload;
      })
      .addCase(CustomerparseCsv.rejected, (state, action) => {
        state.loadingParams.isCustomerParsing = false;
        state.error = action.payload;
      })
      // validateCsvMapping
      .addCase(validateCsvMapping.pending, (state) => {
        state.loadingParams.isValidating = true;
        state.validateResult = null;
        state.error = null;
      })
      .addCase(validateCsvMapping.fulfilled, (state, action) => {
        state.loadingParams.isValidating = false;
        state.validateResult = action.payload;
      })
      .addCase(validateCsvMapping.rejected, (state, action) => {
        state.loadingParams.isValidating = false;
        state.error = action.payload;
      })
      // importCsvData
      .addCase(importCsvData.pending, (state) => {
        state.loadingParams.isImporting = true;
        state.importResult = null;
        state.error = null;
      })
      .addCase(importCsvData.fulfilled, (state, action) => {
        state.loadingParams.isImporting = false;
        state.importResult = action.payload;
      })
      .addCase(importCsvData.rejected, (state, action) => {
        state.loadingParams.isImporting = false;
        state.error = action.payload;
      })
      // importCsvData
      .addCase(importCustomerCsvData.pending, (state) => {
        state.loadingParams.isCustomerImporting = true;
        state.importCustomerResult = null;
        state.error = null;
      })
      .addCase(importCustomerCsvData.fulfilled, (state, action) => {
        state.loadingParams.isCustomerImporting = false;
        state.importCustomerResult = action.payload;
      })
      .addCase(importCustomerCsvData.rejected, (state, action) => {
        state.loadingParams.isCustomerImporting = false;
        state.error = action.payload;
      })
        //update location
      .addCase(updateLocation.pending, (state) => {
        state.loadingParams.updateLocation = true;
        state.error = null;
      })
      .addCase(updateLocation.fulfilled, (state, action) => {
        state.loadingParams.updateLocation = false;

        const updatedLocation = action.payload.data;

        const index = state.locationList.findIndex(
          (loc) => loc._id === updatedLocation._id,
        );

        if (index !== -1) {
          state.locationList[index] = updatedLocation;
        }

        const addedIndex = state.customerAddedLocation.findIndex(
          (loc) => loc._id === updatedLocation._id,
        );

        if (addedIndex !== -1) {
          state.customerAddedLocation[addedIndex] = updatedLocation;
        }
      })
      .addCase(updateLocation.rejected, (state, action) => {
        state.loadingParams.updateLocation = false;
        state.error = action.payload;
      })
      // customer filtered projects
      .addCase(fetchCustomerFilteredProjects.pending, (state) => {
        state.customerFilteredProjectsLoading = true;
        state.customerFilteredProjectsError = null;
      })
      .addCase(fetchCustomerFilteredProjects.fulfilled, (state, action) => {
        state.customerFilteredProjectsLoading = false;
        state.customerFilteredProjects = action.payload?.data ?? [];
        state.customerFilteredProjectsTotal = action.payload?.total ?? 0;
        state.customerFilteredProjectsLimit =
          action.payload?.limit ?? state.customerFilteredProjectsLimit;
        state.customerFilteredProjectsSkip = action.payload?.skip ?? 0;
      })
      .addCase(fetchCustomerFilteredProjects.rejected, (state, action) => {
        state.customerFilteredProjectsLoading = false;
        state.customerFilteredProjectsError = action.payload;
        state.customerFilteredProjects = [];
      })
      // update sub admin/project license
      .addCase(updateSubAdminLicense.pending, (state) => {
        state.updateSubAdminLicenseLoading = true;
        state.updateSubAdminLicenseError = null;
      })
      .addCase(updateSubAdminLicense.fulfilled, (state, action) => {
        state.updateSubAdminLicenseLoading = false;

        const updatedProject =
          action.payload?.data?.project ||
          action.payload?.data ||
          action.payload?.project ||
          null;
        const { projectId, data } = action.meta.arg;
        const index = state.customerFilteredProjects.findIndex(
          (project) => project._id === projectId,
        );

        if (updatedProject?._id) {
          if (index !== -1) {
            state.customerFilteredProjects[index] = updatedProject;
          } else {
            state.customerFilteredProjects.push(updatedProject);
          }
          return;
        }

        if (index !== -1 && data?.license) {
          const project = state.customerFilteredProjects[index];
          project.license = project.license || {};

          Object.entries(data.license).forEach(([key, value]) => {
            const total =
              value && typeof value === "object" && value.total !== undefined
                ? value.total
                : value;
            const date =
              value && typeof value === "object" ? value.date : undefined;
            const previous = project.license[key] || {};
            const used = Number(previous.used) || 0;
            const numericTotal = Number(total) || 0;

            project.license[key] = {
              ...previous,
              total: date ? { total: numericTotal, date } : numericTotal,
              used,
              unused: numericTotal - used,
            };
          });
        }
      })
      .addCase(updateSubAdminLicense.rejected, (state, action) => {
        state.updateSubAdminLicenseLoading = false;
        state.updateSubAdminLicenseError = action.payload;
      })
      // .addCase(deleteLocation.fulfilled, (state, action) => {
      //   const { locationId } = action.payload;
      //   state.locationList = state.locationList.filter(
      //     (loc) => loc._id !== locationId
      //   );
      //   state.customerAddedLocation = state.customerAddedLocation.filter(
      //     (loc) => loc._id !== locationId
      //   );
      // })
  },
});

export const { clearImportResults, clearSetupError,clearMappingStatus,clearCustomerError,setSelectedDepartment,setSelectedLocation,clearDepartmentStatus, resetOtpState, setSelectedCustomer } = customerSlice.actions;

export default customerSlice.reducer;
